import React, { useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdMailOutline } from "react-icons/md";

const FAQ = () => {
  const { t } = useTranslation();
  const {
    title2,
    details2,
    title3,
    details3,
    title4,
    details4,
    title5,
    details5,
    title6,
    details6,
  } = t("helpSupportTab");

  const faqItems = [
    {
      title: title2,
      details:
        "Any Indian citizen over the age of 18 with an Indian bank account/s can invest.",
    },
    {
      title: title3,
      details:
        "No, We ensure end-to-end encryption on our application and payment channels.",
    },
    {
      title: title4,
      details:
        "3% GST is applicable only once (during purchase) in case of purchase of Digital Gold and Digital Silver.",
    },
    {
      title: title5,
      details:
        "Yes, we have a very secured system implemented to ensure that user's data is protected. We abide by the best-in-class practices and guidelines when it comes to data security.",
    },
    {
      title: "Is KYC required to invest?",
      details:
        "Yes, KYC is required to start your saving journey. A one-step new user sign-up using Mobile lets you start your savings journey. You are required to provide PAN, Address, and Bank Account details.",
    },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    const login = sessionStorage.getItem("token");
    if (!login) {
      navigate("/");
    }
  }, []);

  return (
    <div className="AboutBatuk">
      {/* <div style={{ marginBottom: "2rem" }}>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            marginBottom: "2rem",
          }}
        >
          <MdMailOutline size={30} />
          <div>
            <div style={{ fontSize: "1rem", fontWeight: "500" }}>
              Reach us at
            </div>
            <a
              href="mailto:contactus@bajajcapital.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline_link"
            >
              contactus@bajajcapital.com
            </a>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <MdOutlinePhoneInTalk size={30} />
          <div>
            <div style={{ fontSize: "1rem", fontWeight: "500" }}>Call Us</div>
            <a
              href="tel:1800313123123"
              target="_blank"
              rel="noopener noreferrer"
              className="underline_link"
            >
              1800-313-123123
            </a>
          </div>
        </div>
      </div> */}
      <div className="row">
        {faqItems.map((item, index) => (
          <Accordion className="mb-4" key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index + 1}-content`}
              id={`panel${index + 1}-header`}
            >
              {item.title}
            </AccordionSummary>
            <AccordionDetails>{item.details}</AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
